import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';

const classes = {
	currentLink: 'o-customer-lounge-navigation__link-current',
};

@createModule('CustomerLoungeNavigation')
/**
 * customer-lounge-navigation module
 */
export class CustomerLoungeNavigation extends TerrificSpec {
	$ctx: JQuery;
	$currentLink: JQuery;

	start(resolve: Function) {
		this.$ctx = $(this._ctx);
		this.$currentLink = $(`.${classes.currentLink}`, this.$ctx);

		this.initDuplicate();
		this.initCollapseOverview();
		this.collapseContent();

		resolve();
	}

	stop() {}

	initDuplicate() {
		$('.g-grid--customerLounge').prepend(this.$currentLink.nextAll().clone());
	}

	initCollapseOverview() {
		let collapseOverview = false;
		if (location.search && location.search.indexOf('nav=true') > -1) {
			collapseOverview = true;
		} 

		if(this.$currentLink.index() == 0){
			if (collapseOverview) {
				$('.g-grid--customerLounge__content').addClass("collapsed");
				this.$currentLink.addClass('collapsed');
			}else{
				$('.g-grid--customerLounge__content').removeClass("collapsed");
				this.$currentLink.removeClass('collapsed');
			}
		}
		
	}

	collapseContent() {
		this.$currentLink.on('click', () => {
			if (this.$currentLink.hasClass('collapsed')) {
				$('.g-grid--customerLounge__content').slideDown('fast');
				this.$currentLink.removeClass('collapsed');
			} else {
				$('.g-grid--customerLounge__content').slideUp('fast');
				this.$currentLink.addClass('collapsed');
			}
		})
	}

}
